import { AvailableCertifications } from "../Certifications/AvailableCertifications";
import { OrderSummary } from "../OrderSummary/OrderSummary";

export const CartStepOne = () => {
  return (
    <>
      <OrderSummary />
      <AvailableCertifications />
    </>
  );
};
